import React from "react";

export const Privacy = () => {
  return (
    <div className="leading-relaxed text-[#333] max-w-[900px] mx-auto p-5 bg-white min-h-screen box-border">
      <h1 className="text-[#1890ff] border-b-2 border-[#1890ff] pb-[10px] mt-0 text-[2rem] font-bold">
        SurfingCre Privacy Policy / 개인정보처리방침
      </h1>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        서핑크리(SurfingCre) 개인정보처리방침 — 한국어
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        주식회사 금바다(이하 "회사")는 이용자의 개인정보 보호를 최우선으로
        생각하며 관련 법령(개인정보보호법, 정보통신망법 등)을 준수합니다. 본
        방침은 회사가 수집·보유·이용·파기하는 개인정보의 항목, 목적, 보유기간 및
        이용자의 권리에 대해 안내합니다.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        1. 수집하는 개인정보 항목
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">브랜드 회원(필수)</strong>
          <br />
          이름, 생년월일, 주소, 전화번호, 국가, 업종, 사업자등록번호
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">크리에이터 회원(필수)</strong>
          <br />
          이름, 생년월일, 주소, 전화번호, 국가, 업종
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">자동 수집 정보</strong>
          <br />
          접속기록(IP, 로그), 디바이스 정보, 쿠키, 서비스 이용 기록
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">공개 소셜 데이터</strong>
          <br />
          크리에이터의 공개 프로필 및 활동 데이터(공개 범위 내)
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        2. 개인정보의 수집·이용 목적
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          회원 관리(회원가입, 본인확인, 계정관리)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          플랫폼 내 AI 기반 매칭 서비스 제공
        </li>
        <li className="my-[5px] text-[1.4rem]">
          캠페인 계약·집행·정산을 위한 거래 처리
        </li>
        <li className="my-[5px] text-[1.4rem]">
          세금·회계 처리, 영수증·세금계산서 발급
        </li>
        <li className="my-[5px] text-[1.4rem]">고객 문의 및 분쟁 처리</li>
        <li className="my-[5px] text-[1.4rem]">
          서비스 개선 및 통계 분석, 연구 목적(비식별화 처리)
        </li>
        <li className="my-[5px] text-[1.4rem]">마케팅(선택 동의 시)</li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        3. 개인정보 보유 및 이용 기간
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          회원 탈퇴 시 지체 없이 파기(단, 관계 법령에 따른 보관 예외)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          보관 예외:
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              계약·대금·세금 관련 기록: 5년
            </li>
            <li className="my-[5px] text-[1.4rem]">
              소비자 불만 및 분쟁 처리 기록: 3년
            </li>
            <li className="my-[5px] text-[1.4rem]">접속 로그: 3개월</li>
          </ul>
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        4. 개인정보의 제3자 제공
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          회사는 원칙적으로 제3자에게 개인정보를 제공하지 않습니다. 다만 아래의
          경우에는 예외로 합니다.
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              회원의 사전 동의가 있는 경우
            </li>
            <li className="my-[5px] text-[1.4rem]">
              법령에 의해 제출을 요구받은 경우
            </li>
            <li className="my-[5px] text-[1.4rem]">
              캠페인 이행을 위해 브랜드-크리에이터 간 필수정보(이름, 연락처,
              사업자정보 등)를 제공해야 하는 경우(사전 고지/동의 기반)
            </li>
          </ul>
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        5. 개인정보 처리 위탁
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          회사는 서비스 운영을 위해 필요한 업무를 외부 전문업체에 위탁할 수
          있습니다. 위탁 시 개인정보 보호법에 따라 계약서에 보안 및 재위탁 제한
          조건을 포함하고 관리·감독합니다.
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              예: 클라우드 호스팅, 결제/정산 서비스(PG사), 이메일/SMS 발송,
              고객지원 플랫폼
            </li>
          </ul>
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        6. 이용자 권리 및 행사 방법
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          이용자는 언제든지 개인정보 열람·수정·삭제를 요청할 수 있습니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          개인정보 삭제 요청은 회원탈퇴를 통해 진행할 수 있으며, 법령상 보관이
          필요한 경우에는 해당 항목만 별도 보관됩니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          권리 행사는 고객센터 또는 개인정보보호책임자에게 서면·전자우편 등을
          통해 요청할 수 있습니다.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        7. 쿠키 및 추적 기술의 사용
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          회사는 서비스 개선 및 맞춤형 추천을 위해 쿠키를 사용합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          이용자는 브라우저 설정을 통해 쿠키 수집을 거부할 수 있습니다(단, 일부
          서비스 기능이 제한될 수 있습니다).
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        8. 개인정보의 파기 절차 및 방법
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          파기 절차: 보유기간 종료 또는 처리목적 달성 시 지체 없이 파기합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          파기 방법: 전자적 파일은 복구 불가능한 방법으로 삭제하고, 인쇄물은
          분쇄 또는 소각합니다.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        9. 개인정보 보호책임자
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          책임자: 개인정보보호담당자 (주식회사 금바다)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          연락처: support@surfingcre.co.kr (추후 별도 연락처 표기)
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        10. 고지의 의무
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          본 방침은 법령 및 서비스 정책에 따라 변경될 수 있으며, 변경 시
          홈페이지 공지 및 회원에게 통지합니다.
        </li>
      </ul>

      <p className="my-[10px] text-[1.4rem]">발행일: 2025-11-21</p>

      <h2 className="text-[#333] mt-[50px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        SurfingCre Privacy Policy — English
      </h2>

      <p className="my-[10px] text-[1.4rem]">
        Geumbada Co., Ltd. ("Company") operates the SurfingCre platform and is
        committed to protecting users' personal information in accordance with
        applicable laws such as the Personal Information Protection Act and the
        Information and Communications Network Act. This Privacy Policy explains
        what personal information we collect, how we use it, retention periods,
        and users' rights.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        1. Personal Data Collected
      </h2>
      <ol className="my-[10px] pl-[30px] list-decimal">
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">Brand Members (Required)</strong>
          <br />
          Full name, date of birth, address, phone number, country, industry,
          business registration number
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">Creator Members (Required)</strong>
          <br />
          Full name, date of birth, address, phone number, country, industry
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">
            Automatically Collected Data
          </strong>
          <br />
          Access logs (IP, logs), device information, cookies, usage history
        </li>
        <li className="my-[5px] text-[1.4rem]">
          <strong className="font-semibold">Public Social Data</strong>
          <br />
          Creator public profiles and activity data that are publicly available
        </li>
      </ol>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        2. Purpose of Processing Personal Data
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Member management (registration, identity verification, account
          management)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Providing AI-based brand–creator matching services
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Handling campaign agreements, execution, and settlement
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Tax and accounting obligations, issuance of receipts/invoices
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Customer support and dispute resolution
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Service improvement and aggregated statistics (anonymized where
          applicable)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Marketing purposes (with optional consent)
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        3. Retention Period
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Personal data will be deleted promptly upon user withdrawal unless
          retention is required by law.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Legal retention exceptions:
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              Contracts, payments, and tax records: 5 years
            </li>
            <li className="my-[5px] text-[1.4rem]">
              Consumer complaints and dispute records: 3 years
            </li>
            <li className="my-[5px] text-[1.4rem]">Access logs: 3 months</li>
          </ul>
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        4. Third-Party Disclosure
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          The Company does not provide personal data to third parties except in
          the following cases:
          <ul className="my-[10px] pl-[30px] list-disc">
            <li className="my-[5px] text-[1.4rem]">
              With user's prior consent
            </li>
            <li className="my-[5px] text-[1.4rem]">When required by law</li>
            <li className="my-[5px] text-[1.4rem]">
              When necessary for campaign execution to provide essential
              information between brands and creators (e.g., name, contact,
              business info) with prior notice/consent
            </li>
          </ul>
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        5. Data Processing Outsourcing
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          The Company may outsource certain services to trusted third parties
          for operations (cloud hosting, payment/settlement services, email/SMS
          delivery, customer support platform). All vendors are contractually
          bound to protect personal data.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        6. User Rights and How to Exercise Them
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Users can request access, correction, deletion, and suspension of
          their personal data.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Deletion requests can be made via account withdrawal or by contacting
          Customer Support / Data Protection Officer.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        7. Cookies and Tracking Technologies
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Cookies are used to improve service and provide personalized
          recommendations.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Users may disable cookies in their browser settings; however, some
          features may be affected.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        8. Data Retention and Destruction Procedures
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Data is destroyed when the retention period expires or the purpose is
          fulfilled, using irreversible deletion for electronic records and
          shredding/incineration for paper records.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        9. Data Protection Officer
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          DPO: Data Protection Officer (Geumbada Co., Ltd.)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Contact: support@surfingcre.co.kr (to be updated with additional
          contact info)
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        10. Changes to This Policy
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          This Policy may be updated in response to legal/regulatory changes.
          Material changes will be notified on the website and to registered
          users.
        </li>
      </ul>

      <p className="my-[10px] text-[1.4rem]">Date Issued: 2025-11-21</p>
    </div>
  );
};
